<template>
  <svg viewBox="0 0 24 24" v-on="$listeners">
    <path d="M4 11h12v2H4zm0-5h16v2H4zm0 12h7.235v-2H4z" fill="currentColor"></path>
  </svg>
</template>

<script>
export default {
  name: 'menu-toggler',
}
</script>